const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTHDOMAIN,
	databaseURL: import.meta.env.VITE_FIREBASE_DATABASEURL,
	projectId: import.meta.env.VITE_FIREBASE_PROJECTID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGEBUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGINGSENDERID,
	appId: import.meta.env.VITE_FIREBASE_APPID,
}


import { initializeApp, getApps } from 'firebase/app'
import { initializeFirestore, connectFirestoreEmulator, } from 'firebase/firestore'
import { connectAuthEmulator, getAuth, RecaptchaVerifier } from 'firebase/auth'
import { connectDatabaseEmulator, getDatabase } from 'firebase/database'
import { initializeAppCheck, getToken, ReCaptchaEnterpriseProvider } from 'firebase/app-check'

class FB {

	static instance

	constructor() {
		const apps = getApps()
		if (!apps.length) {
			const app = initializeApp(firebaseConfig)
			this.app = app

			this.auth = getAuth()
			this.firestore = initializeFirestore(app, {ignoreUndefinedProperties: true, })
			// this.firestore.settings()
			this.database = getDatabase()

			if (import.meta.env.DEV) {
				connectAuthEmulator(this.auth, 'http://127.0.0.1:5075', {disableWarnings: true})
				connectDatabaseEmulator(this.database, '127.0.0.1', 5073)
				connectFirestoreEmulator(this.firestore, '127.0.0.1', 5071)
			}
		}
	}

	static getInstance() {
		if (!FB.instance) {
			FB.instance = new FB()
		}
		return FB.instance
	}

	async appHeaders(refresh = false) {
		if (!this.appCheck) {
			const provider =  new ReCaptchaEnterpriseProvider(import.meta.env.VITE_RECAPTCHA_KEY)
			this.appCheck = initializeAppCheck(this.app, {provider, isTokenAutoRefreshEnabled: true })
		}

		const appToken = await getToken(this.appCheck, refresh)
		return {
			'X-Firebase-AppCheck': appToken.token
		}
	}

	async getRecaptcha(elementId, callback) {
		return new RecaptchaVerifier(this.auth, elementId, {
			size: 'invisible',
			callback,
		})
	}
}

Object.seal(FB)

export const fb = FB.getInstance()
